export default __webpack_public_path__ + "static/image-7-mob-cece79d9e6814cf1707a2a1d8d1cb476.jpg";